import React, { useRef, useState, useCallback } from 'react';

const SimpleRevealSlider = ({
  beforeSrc,
  afterSrc,
  altBefore = 'Before',
  altAfter = 'After',
  className = '',
  imageFit = 'cover',
}) => {
  const containerRef = useRef(null);
  const [position, setPosition] = useState(50); // percentage
  const [dragging, setDragging] = useState(false);

  const clamp = (val) => Math.max(0, Math.min(100, val));

  const updateFromEvent = useCallback((clientX) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPosition(clamp(pct));
  }, []);

  const onMouseDown = (e) => { setDragging(true); updateFromEvent(e.clientX); };
  const onMouseMove = (e) => { if (dragging) updateFromEvent(e.clientX); };
  const onMouseUp = () => setDragging(false);
  const onTouchStart = (e) => { setDragging(true); updateFromEvent(e.touches[0].clientX); };
  const onTouchMove = (e) => { if (dragging) updateFromEvent(e.touches[0].clientX); };
  const onTouchEnd = () => setDragging(false);

  return (
    <div
      ref={containerRef}
      className={`relative w-full aspect-[4/5] rounded-xl overflow-hidden select-none ${className}`}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseUp}
      onMouseUp={onMouseUp}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* After image (full) */}
      <img src={afterSrc} alt={altAfter} className={`absolute inset-0 w-full h-full ${imageFit === 'contain' ? 'object-contain bg-zinc-950' : 'object-cover'}`} />

      {/* Before image (clipped) */}
      <div
        className="absolute inset-0"
        style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
      >
        <img src={beforeSrc} alt={altBefore} className={`w-full h-full ${imageFit === 'contain' ? 'object-contain bg-zinc-950' : 'object-cover'}`} />
      </div>

      {/* Divider line */}
      <div
        className="absolute top-0 bottom-0 w-0.5 bg-white/80 shadow-[0_0_0_1px_rgba(0,0,0,0.2)]"
        style={{ left: `${position}%` }}
      />

      {/* Handle */}
      <div
        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-white text-zinc-700 shadow-md flex items-center justify-center cursor-ew-resize border border-black/5"
        style={{ left: `${position}%` }}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </div>

      {/* Labels */}
      <div className="absolute top-3 left-3 px-2 py-1 rounded bg-black/40 text-white text-xs backdrop-blur-sm">Before</div>
      <div className="absolute top-3 right-3 px-2 py-1 rounded bg-black/40 text-white text-xs backdrop-blur-sm">After</div>
    </div>
  );
};

export default SimpleRevealSlider;


